// Translation: Register > Landing > Form > TOS dialog (Turkish)
export default Object.freeze({})
